module.exports = __webpack_public_path__ + "static/media/CONTINUE.cf81bad1.svg";